import React, { useState } from 'react';
import CreatePurchaseOrderDropdownPresenter from './CreatePurchaseOrderDropdownPresenter';

import { useFetchMyRfqQuotationsQuery } from '@generated/graphql';
import useDocuments from '../../../../../hooks/useDocuments';
import PreviousDialog from '../PreviousDialog';

interface Props {
  rfqId?: string;
  quotationPartnerId?: string;
}

export interface PreviousState {
  id: string;
  createdAt: string;
}

const CreatePurchaseOrderDropdownContainer = ({
  rfqId,
  quotationPartnerId
}: Props) => {
  const [previous, setPrevious] = useState<PreviousState | undefined>(
    undefined
  );

  const {
    onInitDocumentsCurrentId,
    onUpdateDocumentsOptions,
    onUpdateDocumentsCurrentId
  } = useDocuments();

  const { data } = useFetchMyRfqQuotationsQuery({
    variables: {
      input: {
        rfqId: rfqId ?? '',
        quotationPartnerId: quotationPartnerId ?? ''
      }
    },
    skip: !rfqId || !quotationPartnerId
  });

  const quotations =
    data?.fetchMyRfqQuotations.data &&
    data?.fetchMyRfqQuotations.data.length !== 0
      ? data?.fetchMyRfqQuotations.data
      : [];

  const isLatest = quotations?.[0]?.id === previous?.id;

  const onOk = () => {
    if (isLatest) {
      onInitDocumentsCurrentId();
    } else {
      onUpdateDocumentsCurrentId({ selectedQuotationId: previous?.id ?? '' });
    }

    setPrevious(undefined);
  };

  const onClick = (id: string) => {
    const previousQuotation = quotations.find((v) => v.id === id);

    setPrevious({ id: id, createdAt: previousQuotation?.createdAt ?? '' });
    return onUpdateDocumentsOptions({ listAnchorId: null });
  };

  return (
    <>
      <PreviousDialog
        open={Boolean(previous)}
        onClose={() => setPrevious(undefined)}
        onOk={onOk}
      />
      <CreatePurchaseOrderDropdownPresenter
        quotations={quotations}
        onClick={onClick}
      />
    </>
  );
};

export default CreatePurchaseOrderDropdownContainer;
